var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCheckCircle48Line = function SvgIconCheckCircle48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 40.699c-9.21 0-16.7-7.49-16.7-16.7 0-9.21 7.49-16.7 16.7-16.7 9.21 0 16.7 7.49 16.7 16.7 0 9.21-7.49 16.7-16.7 16.7Zm0-30c-7.33 0-13.3 5.97-13.3 13.3 0 7.33 5.97 13.3 13.3 13.3 7.33 0 13.3-5.97 13.3-13.3 0-7.33-5.97-13.3-13.3-13.3Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.65 30.529h-.06c-.79-.02-1.53-.35-2.07-.93l-4.76-5.14 2.49-2.31 4.41 4.76 9.14-9.11 2.4 2.41-9.51 9.47c-.55.55-1.27.85-2.05.85h.01Z",
    fill: "current"
  })));
};
export default SvgIconCheckCircle48Line;